var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInPostGenerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4729 36C28.414 36 36.4729 27.9411 36.4729 18C36.4729 8.05888 28.414 0 18.4729 0C8.53177 0 0.4729 8.05888 0.4729 18C0.4729 27.9411 8.53177 36 18.4729 36Z",
    fill: "#E1EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9956 9.65384H13.1774C12.2399 9.65384 11.4729 10.3894 11.4729 11.2885V24.3654C11.4729 25.2644 12.2314 26 13.1689 26H23.4047C24.3422 26 25.1092 25.2644 25.1092 24.3654V14.5577L19.9956 9.65384ZM23.4047 24.3654H13.1774V11.2885H19.1433V15.375H23.4047V24.3654Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4256 9L23.7899 10.3479L22.382 10.9615L23.7899 11.5752L24.4256 12.9231L25.0649 11.5752L26.4729 10.9615L25.0649 10.3479L24.4256 9Z",
    fill: "#1570EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5233 14.8846H14.0817C13.5825 14.8846 13.1775 15.273 13.1775 15.7517V24.806C13.1775 25.2847 13.5825 25.6731 14.0817 25.6731H23.5233C24.0225 25.6731 24.4275 25.2847 24.4275 24.806V15.7517C24.4275 15.273 24.0225 14.8846 23.5233 14.8846ZM23.5233 24.81C17.2261 24.8086 14.0775 24.8073 14.0775 24.806C14.0789 18.7671 14.0803 15.7477 14.0817 15.7477C20.3789 15.749 23.5275 15.7504 23.5275 15.7517C23.5261 21.7906 23.5247 24.81 23.5233 24.81ZM14.8453 18.9289H16.5145V24.0777H14.8453V18.9289ZM15.6806 18.225C16.2136 18.225 16.6481 17.8096 16.6481 17.2972C16.6481 17.1753 16.6231 17.0547 16.5745 16.9421C16.5258 16.8296 16.4546 16.7273 16.3647 16.6411C16.2749 16.555 16.1682 16.4866 16.0509 16.44C15.9335 16.3934 15.8077 16.3694 15.6806 16.3694C15.5536 16.3694 15.4277 16.3934 15.3104 16.44C15.193 16.4866 15.0863 16.555 14.9965 16.6411C14.9066 16.7273 14.8354 16.8296 14.7868 16.9421C14.7381 17.0547 14.7131 17.1753 14.7131 17.2972C14.7117 17.8096 15.1448 18.225 15.6806 18.225ZM19.2286 21.5303C19.2286 20.8587 19.3622 20.2087 20.2298 20.2087C21.0848 20.2087 21.0975 20.976 21.0975 21.5735V24.0777H22.7653V21.2539C22.7653 19.8675 22.4531 18.8008 20.7642 18.8008C19.9528 18.8008 19.4086 19.2283 19.185 19.6329H19.1625V18.9289H17.5608V24.0777H19.2286V21.5303Z",
    fill: "#1570EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2001 14.8846H12.666V15.8654H13.1774L14.2001 15.375V14.8846Z",
    fill: "#1570EF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.64149,
    height: 0.862004,
    transform: "matrix(1 0 0 -1 13.6921 15.7466)",
    fill: "#E1EDFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6921,
    y: 15.7466,
    width: 0.508055,
    height: 8.62004,
    fill: "#E1EDFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 0.514671,
    height: 13.2948,
    transform: "matrix(-1 0 0 1 13.6921 11.0719)",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInPostGenerator);
export default __webpack_public_path__ + "static/media/LinkedINPostGenerator.b776195e8b85b65d3c70034868cd4138.svg";
export { ForwardRef as ReactComponent };